module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgement"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01"
    }
  }, [_vm._v("1    The Ghosts of John’s Pass")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h1"
    }
  }, [_vm._v("John Levique")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h2"
    }
  }, [_vm._v("Yankee Brothers in Southern Soil")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h3"
    }
  }, [_vm._v("Eleanor Key")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h4"
    }
  }, [_vm._v("Captain Hubbard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h5"
    }
  }, [_vm._v("Pirate Legends")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2    The Ghosts of St. Pete Beach")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Comfort and Joy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Silas Dent")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Castle Hotel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hurricane Restaurant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don CeSar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snippets—Short Stories from St. Pete Beach")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3    The Ghosts of Gulfport")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Peninsula")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Karen Gregory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cat and the Casino")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Trolley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rolyat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("La Cote de Basque Winehouse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunshine Skyway")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4    The Ghosts of Downtown St. Petersburg")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bathroom and the Museum")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Vinoy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Home of Ott and Julia Whitted")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sutphin House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Coliseum Ballroom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Flamboyant Mayors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Martha Washington Hotel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haslam’s Book Store")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bed and Breakfast Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5    The Ghosts of Clearwater")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Belleview Biltmore")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fort Harrison Hotel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Safety Harbor Resort and Spa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21784071","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0